import { getCountryFlag } from '@home/_config/countries';

/**
 * 全球emoji图标
 */
export const COUNTRY_EMOJI_GLOBAL = '🌍';

/**
 * 美国国旗
 */
export const COUNTRY_IMG_US = getCountryFlag('us');

/**
 * Global全球常量
 */
export const GLOBAL_REGION: IRegion = {
  area_code: 'global',
  area_name_en: 'Global',
  area_name_ch: '全球',
  country_set: [
    {
      country_code: 'global',
      country_name_en: 'Global',
      country_name_ch: '全球',
    },
  ],
};
